/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjEyIDIuNUg4Ljg5VjQuMjdINy4xMlYyLjVaTTcuMTIgNy4xMkg4Ljg5VjguODlINy4xMlY3LjEyWk04Ljg5IDExLjczSDcuMTJWMTMuNUg4Ljg5VjExLjczWiIgZmlsbD0iaW5oZXJpdCIvPg==";